// @ts-strict-ignore
import React, { FC } from 'react'
import classnames from 'classnames'
import { Answer } from 'mytours-read-api-typescript'
import { IonRow, IonInput } from '@ionic/react'
import Button from '../../common/components/Button'
import strings from 'mobile_web/strings'
import { InputChangeEventDetail } from '@ionic/core'
import '../styles/freeTextAnswer.less'

interface FreeTextAnswerProps {
	isAnswered?: boolean
	answers?: Answer[]
	hasAttempts: boolean
	onSubmit?: (answer: string) => void
	textAnswer?: string
	onChange?: (e: CustomEvent<InputChangeEventDetail>) => void
}

const FreeTextAnswer: FC<FreeTextAnswerProps> = ({
	isAnswered,
	answers,
	onChange,
	onSubmit,
	textAnswer,
	hasAttempts,
}) => {
	const isCorrect = answers?.some(answer => answer.answer_text.toLowerCase() === textAnswer.toLowerCase())

	return (
		<IonRow className="free-text">
			<IonInput
				value={textAnswer}
				onIonChange={onChange}
				disabled={isAnswered}
				placeholder={strings.free_text_answer_input_placeholder}
			/>
			<Button
				fill="clear"
				onClick={onSubmit}
				ariaLabel={strings.submit}
				disabled={(isAnswered && !hasAttempts) || (isCorrect && hasAttempts && isAnswered)}
				className={classnames({ '-correct': isCorrect && isAnswered, '-incorrect': !isCorrect && isAnswered })}
			>
				{hasAttempts && isAnswered && !isCorrect ? (
					<>{strings.try_again}</>
				) : isAnswered && isCorrect ? (
					<i className={`far fa-${isCorrect ? 'circle-check' : 'circle-xmark'}`} />
				) : (
					<>{strings.submit}</>
				)}
			</Button>
		</IonRow>
	)
}

export default FreeTextAnswer
